<template>
  <el-container>
    <el-main style="padding:0;width:100vh">
      <vm-table
          ref="vmTable"
          :filter.sync="filter"
          module="basic"
          url="pui/puiProcessList">
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="编号">
              <el-input v-model.trim="filter.puiNo" clearable/>
            </vm-search>
            <vm-search label="产品名称">
              <el-input v-model.trim="filter.productName" clearable/>
            </vm-search>
            <vm-search label="产品型号">
              <el-input v-model.trim="filter.productModel" clearable/>
            </vm-search>
          </div>
        </template>
        <el-table-column prop="billNo" width="120" align="center" label="编号">
          <template slot-scope="scope">
            <span style="color: #2d8cf0; cursor: pointer" @click="goto(scope.row)">{{scope.row.billNo}}</span>
            <el-button
                v-clipboard="scope.row.billNo"
                v-clipboard:success="clipboardSuccessHandler"
                v-clipboard:error="clipboardErrorHandler"
                round
                icon="el-icon-chat-line-square"/>
          </template>
        </el-table-column>
        <el-table-column prop="releaseTime" align="center" label="下达时间"/>
        <el-table-column prop="product" align="center" label="产品名称"/>
        <el-table-column prop="issueDesc" align="center" label="问题描述"/>
        <el-table-column prop="approveResult" align="center" label="处理意见">
          <template slot-scope="scope">
            <el-input v-model="scope.row.approveResult" type="textarea" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column
            label="操作"
            align="center"
            class-name="vm-table_operate"
            width="120px">
          <template slot-scope="scope">
            <el-button @click="submit(scope.row.pkid,scope.row.approveResult)">提交</el-button>
          </template>
        </el-table-column>
      </vm-table>
      <p-u-i-edit ref="editPage" @save-success="getList(1)"/>
    </el-main>
  </el-container>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";
  import PUIEdit from "@/views/afterSalesManagement/PUI/PUIEdit";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "PUI",
    components: {PUIEdit, VmTable, VmSearch},
    data() {
      return {
        constant,
        // addAuth: this.$auth(252),
        // editAuth: this.$auth(253),
        // delAuth: this.$auth(254),
        currentId: loginUtil.getUserId(),
        ids: [],
        filter: {
          puiNo: "",
          applyType:"",
          productName: "",
          productModel: "",
          versionNo: "",
          status: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      submit(pkid,approveResult) {
        let params= {
          approveResult: approveResult,
        };
        this.$confirm("确定提交吗?", "提示", { type: "warning" }).then(() => {
          this.$http.get("basic", `pui/submitApprove/${pkid}`, params).then(() => {
            this.$message.success("操作成功");
            this.getList(-1);
          });
        });
      },
      select(selection) {
        this.ids = [];
        for (let item of selection) {
          this.ids.push(item.pkid);
        }
      },
      deleteRow(row) {
        this.ids = [];
        this.ids.push(row.pkid);
        this.deleteRows();
      },
      clipboardSuccessHandler(e) {
        this.$message.success("复制单号成功");
      },
      clipboardErrorHandler(e) {
        this.$message.error("复制单号失败");
      },
      goto(row) {
        this.$router.push({
          path: "/PUI",
          query: {
            billType: 31,
            billId: row.masterId,
            $tabName: row.billNo,
          },
        });
      },
      deleteRows() {
        if (this.ids.length == 0) {
          this.$message.error("请先选择删除项");
          return;
        }
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic", "pui", this.ids)
            .then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
              this.idList = "";
            });
        });
      },
    },
  };
</script>
<style scoped>
</style>
